export default __webpack_public_path__ + "static/media/Band CT Too Big.fce4634b.mp4";